import { CommonModule } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TrimSpacesDirective } from '@directives/trim-spaces.directive';
import { EditorComponentBase } from 'ngx-lib';
import { ValidationErrorMessageComponent } from '../../validation-error-message/validation-error-message.component';

@Component({
    selector: 'app-textarea-editor',
    templateUrl: './textarea-editor.component.html',
    styleUrls: ['./textarea-editor.component.scss'],
    imports: [CommonModule, FormsModule, ValidationErrorMessageComponent, TrimSpacesDirective]
})
export class TextareaEditorComponent extends EditorComponentBase<string> implements OnInit {
    shouldTrimSpaces = signal(false);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.shouldTrimSpaces.set(!!this.additionalInfo?.shouldTrimSpaces);
    }

    dataChanged() {
        this.valueChange.emit(true);
        this.validate();
    }
}
